import React from 'react';

import TrendingFlatIcon from 'mdi-react/TrendingFlatIcon';
import { HeaderCellProps } from './interfaces';

import classes from './HeaderCell.module.scss';

export const HeaderCell: React.FC<HeaderCellProps> = (props) => {
  const { sortDirection, sortable, children, ...restProps } = props;

  return (
    <th {...restProps} className={`${restProps.className} ${classes.cell} ${sortable ? classes.sortable : ''}`}>
      <span className={classes.text}>
        {props.children}{' '}
        {sortDirection && <TrendingFlatIcon className={`${classes[sortDirection]} ${classes.sortIcon}`} />}
      </span>
    </th>
  );
};
